import Enllac from 'components/corporatiu/Enllac';
import Text from 'components/corporatiu/Text';
import Imatge from 'components/corporatiu/Imatge/Imatge';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from '../DestacatBasic/destacatBasic.module.scss';

const DestacatIdioma = (props) => {
    const {
        item,
        routePath,
        portal,
        className,
        testId,
        mostrarEntradeta,
        mostrarAvantitol,
        estil,
        tema,
        lang = 'ca',
        edicio = true,
        tipusImatge = 'web_destacat'
    } = props;
    const { id, entradeta, imatges, domini, tipologia, avantitol, agrupacions } = item || props;
    const titol = item[`titol_${lang}`] || item.titol;
    const slugEdicio = agrupacions && agrupacions.length > 0 ? agrupacions[0].desc : '';
    const textAvantitol = avantitol || (agrupacions && agrupacions.length > 0 ? agrupacions[0].desc : '');

    const route = {
        type: lang !== 'ca' ? routePath + '_' + lang : routePath,
        slug: edicio ? slugEdicio : titol,
        id: id,
        domini: domini,
        tipologia: tipologia
    };

    const stylesDestacat = clsx({
        [styles.destacatBasic]: true,
        [styles[portal]]: !__isEmpty(portal),
        [styles[estil]]: !__isEmpty(estil),
        [styles[tema]]: !__isEmpty(tema),
        [className]: !__isEmpty(className)
    });

    if (!titol) {
        return <></>;
    }

    return (
        <div key={`destacat-idioma-${id}`} className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            {imatges && (
                <Enllac route={route} dataTestId='destacat-enllac'>
                    <div className={styles.imatgeWrapper}>
                        <Imatge
                            imatges={imatges}
                            className={styles.imatge}
                            tipus={tipusImatge}
                            numColumnsRow='2'
                            aria-hidden='true'
                            layout='fill'
                            priority={false}
                            data_testid='destacat-img'
                        />
                    </div>
                </Enllac>
            )}
            <div className={styles.contentWrapper}>
                {mostrarAvantitol && textAvantitol && (
                    <span className={styles.avantitol} data-testid='avantitol'>
                        {textAvantitol}
                    </span>
                )}

                <Enllac route={route} dataTestId='destacat-enllac'>
                    <Text tag='div' className={styles.titol} text={titol} dataTestId='destacat-basic-titol' />
                </Enllac>

                {mostrarEntradeta && entradeta && (
                    <Text className={styles.entradeta} tag='p' text={entradeta} dataTestId='destacat-basic-entradeta' />
                )}
            </div>
        </div>
    );
};

export default DestacatIdioma;
